import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import clsx from 'clsx';
import { useWindowSize } from '../utils/window-size';
import ColumnInner from './column-inner';
import { ANIMATION_DURATION, functionDelay, generateIngredientsList } from './utils';

const ColumnComponentDesktop = ({
  data,
  index,
  isActive,
  setActiveItem,
}) => {
  const {
    title,
    ingredients,
    description,
    inner_cta_bg: buyButtonBg,
    inner_cta_text: buyButtonText,
    inner_cta_link_url: ctaLinkUrl,
    lifestyle_images: lifestyleImages,
    is_lifestyle_image_bordered: isLifestyleImageBordered,
    lifestyle_image_border_color: lifestyleImageBorderColor,
    cta_text: ctaText,
    desk_cta_color: ctaTextColor,
    text_color: textColor,
    image_bg: imageBgDesktop,
    video_desktop: videoDesktop,
    product_list: productsList,
  } = data;

  const [isHovered, setIsHovered] = useState(false);
  const [zIndexClass, setZIndexClass] = useState('');

  useEffect(
    () => (isActive ? setZIndexClass('z-[5]') : functionDelay({ fn: setZIndexClass, value: '' })),
    [isActive],
  );

  const { isTabletOrSmaller } = useWindowSize();

  const ctaItem = (text) => {
    if (text.length < 1)
      return <div className='block pb-[68px]'></div>;
    const CTA_CLASS = clsx(
      'mt-[16px] block p-[20px]',
      'bg-[#1E1E1E]/30 hover:bg-[#1E1E1E]/70',
      `transition-bg duration-${ANIMATION_DURATION} ease-in-out`,
      'font-medium tracking-[0.24px] uppercase cursor-pointer'
    )
    return <p className={CTA_CLASS} style={`color: ${ctaTextColor}`}>{text}</p>;
  };

  const polygonPoints = [
    Number((100 / 6) * index),
    Number((100 / 6) * (index + 1)),
  ];

  const innerMediaData = {
    imageBgDesktop,
    videoDesktop,
    lifestyleImages
  };
  const innerContentData = {
    title,
    productsList,
    buyButtonBg,
    buyButtonText,
    description,
    ctaLinkUrl
  };

  const handleColumnClick = (e) => {
    const elem = e.target;
    const { itemIndex } = elem.closest('[data-item-index]').dataset;
    setActiveItem(Number(itemIndex));
  };

  const handleColumnClose = (e) => {
    e.stopPropagation();
    setActiveItem(Number(-1));
  };

  return (
    <column
      className={clsx(
        'flex justify-between flex-1 h-full group',
        'px-0 pt-[98px] pb-[0px]',
        `text-center`,
        `${isActive ? 'is-active' : ''}`,
      )}
      style={`color: ${textColor}`}
      data-item-index={index}
      onClick={(e) => handleColumnClick(e)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <column-content className="flex flex-col flex-1 h-full justify-between">
        <column-title className="pb-[12px] px-[15px] v-h5 relative z-[4]">
          {title}
        </column-title>
        <column-desc-and-cta
          className={clsx(
            'relative z-[4] v-eyebrow-sm top-[15px]',
            `duration-${ANIMATION_DURATION}`,
            'opacity-0 group-hover:opacity-100 group-hover:top-0',
          )}
        >
          {generateIngredientsList(ingredients)}
          {ctaItem(ctaText)}
        </column-desc-and-cta>
      </column-content>
      <column-modal
        className={clsx(
          `absolute inset-0 h-full w-[100dvw]`,
          `transition-all duration-${ANIMATION_DURATION} ease-in-out`,
          `${zIndexClass}`,
          // eslint-disable-next-line max-len
          `[.is-active_&]:[clip-path:polygon(0%_0px,100%_0px,100%_100%,0%_100%)!important]`,
        )}
        style={`clip-path: ${`polygon(${polygonPoints[0]}% 0,
                      ${polygonPoints[1]}% 0,
                      ${polygonPoints[1]}% 100%,
                      ${polygonPoints[0]}% 100%);`}`}
      >
        <ColumnInner
          mediaData={innerMediaData}
          contentData={innerContentData}
          index={index}
          handleColumnClose={handleColumnClose}
          isHovered={isTabletOrSmaller ? false : isHovered}
          isOpened={isActive}
          isLifestyleImageBordered={isLifestyleImageBordered}
          lifestyleImageBorderColor={lifestyleImageBorderColor}
        />
      </column-modal>
    </column>
  );
};

export default ColumnComponentDesktop;